const OperationalIssuesIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0H24.5C28.9183 0 32.5 3.58172 32.5 8V24C32.5 28.4183 28.9183 32 24.5 32H8.5C4.08172 32 0.5 28.4183 0.5 24V8Z"
        fill="#E01E4E"
      />
      <path
        d="M16.5 21C16.7833 21 17.0208 20.9042 17.2125 20.7125C17.4042 20.5208 17.5 20.2833 17.5 20C17.5 19.7167 17.4042 19.4792 17.2125 19.2875C17.0208 19.0958 16.7833 19 16.5 19C16.2167 19 15.9792 19.0958 15.7875 19.2875C15.5958 19.4792 15.5 19.7167 15.5 20C15.5 20.2833 15.5958 20.5208 15.7875 20.7125C15.9792 20.9042 16.2167 21 16.5 21ZM15.5 17H17.5V11H15.5V17ZM16.5 26C15.1167 26 13.8167 25.7375 12.6 25.2125C11.3833 24.6875 10.325 23.975 9.425 23.075C8.525 22.175 7.8125 21.1167 7.2875 19.9C6.7625 18.6833 6.5 17.3833 6.5 16C6.5 14.6167 6.7625 13.3167 7.2875 12.1C7.8125 10.8833 8.525 9.825 9.425 8.925C10.325 8.025 11.3833 7.3125 12.6 6.7875C13.8167 6.2625 15.1167 6 16.5 6C17.8833 6 19.1833 6.2625 20.4 6.7875C21.6167 7.3125 22.675 8.025 23.575 8.925C24.475 9.825 25.1875 10.8833 25.7125 12.1C26.2375 13.3167 26.5 14.6167 26.5 16C26.5 17.3833 26.2375 18.6833 25.7125 19.9C25.1875 21.1167 24.475 22.175 23.575 23.075C22.675 23.975 21.6167 24.6875 20.4 25.2125C19.1833 25.7375 17.8833 26 16.5 26Z"
        fill="white"
      />
    </svg>
  )
}

export default OperationalIssuesIcon
